import mixMethods from "@/mixin.js" // Mixin anexados a Vue
export default class MapperReserva {
  constructor(formularios, carrito, asignables) {
    this.formularios = formularios
    this.servicios = carrito
    this.asignables = asignables
    this.paxFromHoteles = []
  }
  setFormularios(formularios) {
    this.formularios = formularios
  }
  setVuexStore(store) {
    // .getters['pasajeros/getPaxToAsingar'] SETEADO desde al main.js
    this.store = store
  }
  pax2Servicios() {
    this.pax2Hoteles()
    this.buscarPaxTickets()
    this.buscarPax2Traslados()
    return this.servicios
  }
  pax2Hoteles() {
    // Busca los pasajeros para cada servicio
    this.servicios.hoteles.map(this.getPasajerosByHotel, this)
    if (this.servicios.cupos.length > 0) {
      // Si this.paxFromHoteles es mayor a cero quiere decir que el cupo se esta reservado con un hotel, por lo que toma los pasajero del rooming, caso contrario los busca del formario
      const paxCupos =
        this.paxFromHoteles.length > 0
          ? mixMethods.methods._$uniqueObjects(this.paxFromHoteles, "dni")
          : this.formularios.flat()[0].form.pasajeros
      this.servicios.cupos[0]["pasajeros"] = paxCupos
    }
  }
  getPasajerosByHotel(hotel) {
    // Itera las habitaciones del hotel, se concatena el indice en donde esta ubicada la habitacion para luego hacer comparaciones
    hotel.habitaciones.map(function(hab, index) {
      let identificador = `${hotel.unico_carrito}-${index}`
      this.getPasajerosByHabitacion(hab.habitacion, identificador)
    }, this)
    return hotel
  }
  getPasajerosByHabitacion(habitacion, identificador) {
    // Se busca el formulario que corresponde a la habiracion por el identificador o belong
    let formulario = this.formularios
      .filter(fs => {
        let formulario = fs.find(f => f.form.belong == identificador)
        if (formulario == undefined) {
          return false
        }
        return true
      })
      .flat()
      .find(fr => fr.form.belong == identificador)
    // BUsqueda de rooming
    let rooming = formulario.form.pasajeros.map(p => {
      // Si el p.idSeleccionado es distinto de null quiere decir que actual pasajero debe buscarse en los asginables que son el listado de pasajeros ya ingresados manualmente.
      if (p.idSeleccionado != null) {
        // Se divide en parte para remover el ultimo dato que es el id del pasajero, este id no es unico, lo deferencia el resto del string
        let pre = p.idSeleccionado.split("-")
        pre.pop()
        // Se formulario de la habitacion del pasajero  que fue seleccionado
        let asignable = this.asignables.find(a => {
          return a.belong === pre.join("-")
        })
        // Se busca el pasajero seleccionado y se retorna
        return asignable.pasajeros.find(pas => {
          return `${pas.belong}-${pas.id}` === p.idSeleccionado
        })
      }
      // REtornado pasajero que fue ingresado manualmente, no se usó el select
      return p
    })
    this.paxFromHoteles = this.paxFromHoteles.concat(rooming)
    habitacion["rooming"] = rooming
    return habitacion
  }
  buscarPaxTickets() {
    this.servicios.tickets.forEach(t => {
      let formulario = this.formularios
        .filter(fs => {
          let formulario = fs.find(f => f.form.belong == t.unico_carrito)
          if (formulario == undefined) {
            return false
          }
          return true
        })
        .flat()
        .find(fr => fr.form.belong == t.unico_carrito)

      let rooming = formulario.form.pasajeros.map(p => {
        // Si el p.idSeleccionado es distinto de null quiere decir que actual pasajero debe buscarse en los asginables que son el listado de pasajeros ya ingresados manualmente.
        if (p.idSeleccionado != null) {
          // Se divide en parte para remover el ultimo dato que es el id del pasajero, este id no es unico, lo deferencia el resto del string
          let pre = p.idSeleccionado.split("-")
          pre.pop()
          // Se formulario de la habitacion del pasajero  que fue seleccionado
          let asignable = this.asignables.find(a => {
            return a.belong === pre.join("-")
          })
          // Se busca el pasajero seleccionado y se retorna
          return asignable.pasajeros.find(pas => {
            return `${pas.belong}-${pas.id}` === p.idSeleccionado
          })
        }
        // REtornado pasajero que fue ingresado manualmente, no se usó el select
        return p
      })
      t["rooming"] = rooming
      return t
    })
  }
  buscarPax2Traslados() {
    this.servicios.traslados.forEach(t => {
      let rooming = this.servicios.hoteles
        .find(h => h.unico_carrito === t.unico_hotel)
        .habitaciones.map(hab => {
          return hab.habitacion.rooming
        })
      t["rooming"] = rooming.flat()
    })
  }
}
